import * as tslib_1 from "tslib";
/** @jsx jsx */

import { jsx, css } from "@emotion/core";
import PropTypes from "prop-types";
import { useTheme } from "./Theme/Providers";
var MOBILE_HEIGHT = "56px";
var DESKTOP_HEIGHT = "64px";
export var Toolbar = function Toolbar(_a) {
  var compressed = _a.compressed,
      other = tslib_1.__rest(_a, ["compressed"]);

  var _b;

  var theme = useTheme();
  return jsx("div", tslib_1.__assign({
    css: [(_b = {
      minHeight: MOBILE_HEIGHT,
      display: "flex",
      position: "relative",
      alignItems: "center",
      paddingLeft: theme.spaces.md,
      paddingRight: theme.spaces.md
    }, _b[theme.mediaQueries.md] = {
      minHeight: DESKTOP_HEIGHT,
      paddingLeft: theme.spaces.lg,
      paddingRight: theme.spaces.lg
    }, _b), compressed ? {
      minHeight: "48px !important"
    } : undefined]
  }, other));
};
Toolbar.propTypes = {
  compressed: PropTypes.bool,
  children: PropTypes.node
};
export var useResponsiveBodyPadding = function useResponsiveBodyPadding() {
  var _a;

  var theme = useTheme();
  return css((_a = {
    paddingTop: MOBILE_HEIGHT
  }, _a[theme.mediaQueries.md] = {
    paddingTop: DESKTOP_HEIGHT
  }, _a));
};